import MainPageCommonService from "../../../../services/main-page/MainPageCommonService";
import AsyncHelper from "../../../../helpers/AsyncHelper";

export default class MainPageFourthScreenCommon extends MainPageCommonService {
    public readonly $holder: JQuery;

    public readonly $screen: JQuery;
    public readonly $screenContainer: JQuery;
    public readonly $title: JQuery;
    public readonly $roundsBlock: JQuery;
    public readonly $roundsBlockItems: JQuery;

    public isAnimationStarted: boolean = false;

    private RECURSIVE_DELAY: number = this.ANIMATION_DURATION_IN_SECONDS * 1000 / 100;

    public readonly selectors = {
        screen: ".js-main-page-digits-section",
        screenContainer: ".js-main-page-digits-section-container",
        title: ".js-main-page-digits-section-head-title",
        roundsBlock: ".js-main-page-digits-section-rounds-block",
        roundsBlockItems: ".js-main-page-digits-section-rounds-block-item",
        roundsBlockItemTextContent: ".js-main-page-digits-section-rounds-block-item-text-content",
    };

    constructor($holder: JQuery) {
        super();

        this.$holder = $holder;

        this.$screen = this.$holder.find(this.selectors.screen);
        this.$screenContainer = this.$screen.find(this.selectors.screenContainer);
        this.$title = this.$screenContainer.find(this.selectors.title);
        this.$roundsBlock = this.$screenContainer.find(this.selectors.roundsBlock);
        this.$roundsBlockItems = this.$roundsBlock.find(this.selectors.roundsBlockItems);

        this.setDefaultCirclesValues = this.setDefaultCirclesValues.bind(this);
        this.setStartedCirclesAnimation = this.setStartedCirclesAnimation.bind(this);
        this.setCircleProgressLine = this.setCircleProgressLine.bind(this);
    }

    /**
     * Задать дефолтные значения для кругов при переходе на экран
     * @public
     */
    public setDefaultCirclesValues(): void {
        /**
         * проходим по $roundsBlockItems, их 3 элемента
         */
        this.$roundsBlockItems.each((_, item) => {
            const progressCircle = $(item).find(".rounds-block-item-progress");

            /* Получаем высоту svg */
            const itemHeight = item.children[0].clientHeight;
            if (!itemHeight) return;

            /* Получаем радиус svg */
            let radius = itemHeight / 2;

            // Получаем окружность, (передаем радиус*2*PI)
            let circumference = radius * 2 * Math.PI;
            progressCircle.css({strokeDasharray: circumference});

            /* задаем смещение линии наложение на 0% по дефолту */
            this.setCircleProgressLine(progressCircle, circumference, 0);
        })
    }

    /**
     * Задать стартовую анимацию на круги при открытии страницы и переходе на 4 экран
     * @public
     */
    public async setStartedCirclesAnimation(): Promise<void> {
        if (this.isAnimationStarted) return;
        this.isAnimationStarted = true;

        const items = Array.from(this.$roundsBlockItems);

        /* Проходим по $roundsBlockItems и задаем для каждого анимацию заполнения круга с progress */
        for (const item of items) {
            setTimeout(async () => {
                const progressCircle = $(item).find(".rounds-block-item-progress");

                const itemHeight = item.children[0].clientHeight;
                if (!itemHeight) return;

                let radius = itemHeight / 2;

                // Получаем окружность, (передаем радиус*2*PI)
                let circumference = radius * 2 * Math.PI;
                progressCircle.css({strokeDasharray: circumference});

                const animateRecursiveCircleProgress = async () => {
                    for (let count = 0; count <= 100; count++) {
                        this.setCircleProgressLine(progressCircle, circumference, count);

                        await AsyncHelper.delay(this.RECURSIVE_DELAY);
                    }
                };

                await animateRecursiveCircleProgress();
            }, 0);
        }

        await AsyncHelper.delay(this.ANIMATION_DURATION_IN_SECONDS, true);

        this.isAnimationStarted = false;
    }

    /**
     * Получить смещение линии наложения (окружость - (переденный процент / 100) * окружность).
     * @public
     * @param selector
     * @param circumference
     * @param percent
     */
    public setCircleProgressLine(selector: JQuery<HTMLElement>, circumference: number, percent: number) {
        selector.css({strokeDashoffset: `${circumference - (percent / 100) * circumference}`});
    }
}
